import { get } from 'lodash';

import GrpcError from '~/common/errors/grpcError';
import GRPC_USER from "./UserService";

export const getGrpcMessage = response =>
  get(response, "headers['grpc-message']");

export const isUserDuplicationError = error =>
  error instanceof GrpcError &&
  error.grpcCode === GRPC_USER.ALREADY_EXISTS.GENERAL;
